import { useState, useEffect, useMemo, } from "react";
import jQuery from 'jquery'
import { createBrowserRouter, RouterProvider, useLocation, } from "react-router-dom";
import { FsLightboxContextProvider } from "./context/FsLightboxContext";
import Layout from "./pages/layout";
import Home from "./pages/home/Home";
import Rooms from "./pages/rooms";
import Gallery from "./pages/gallery";
import Facility from "./pages/facility";
import RoomDetail from "./pages/rooms/detail";
import Base from './pages/utils/base'
import Article from "./pages/article";
import Preloader from "./pages/components/Preloader";
import Footer from "./pages/components/Footer.jsx";
import FloatingButton from "./pages/components/FloatingButton.jsx";
import NotFound from "./pages/NotFound"
import Maintenance from "./pages/Maintenance"

// import 'tempusdominus-bootstrap-4.js'

window.$ = jQuery

import { useTranslation } from "react-i18next";



function App() {
	var base = new Base()
	const {t, i18n} = useTranslation()
	const router = createBrowserRouter(
		[
			{
				path: "/",
				// element: <Layout/>,
				Component: Layout,
				children: [
					{
						index: true,
						// loader: Preloader,
						// element: <Home />,
						Component: Home,
						// lazy: Home
					},
					{
						// loader: Preloader,
						path: "/rooms",
						Component: Rooms,
					},
					{
						// loader: Preloader,
						path: "/rooms/detail",
						Component: RoomDetail,
					},
					{
						// loader: Preloader,
						path: "/gallery",
						Component: Gallery,
					},
					{
						// loader: Preloader,
						path: "/facility",
						Component: Facility,
					},
					{
						// loader: Preloader,
						path: "/article",
						Component: Article,
					},
					// {
					//   path: "todos",
					//   action: todosAction,
					//   loader: todosLoader,
					//   Component: TodosList,
					//   ErrorBoundary: TodosBoundary,
					//   children: [
					//     {
					//       path: ":id",
					//       loader: todoLoader,
					//       Component: Todo,
					//     },
					//   ],
					// },
					// {
					//   path: "deferred",
					//   loader: deferredLoader,
					//   Component: DeferredPage,
					// },
				],
			},
			// {
			// 	path: '*',
			// 	Component: Maintenance,
			// }
		],
		{scrollRestoration: "auto",}
	)

	let arr = [
		// window.location.origin + "assets/vendors/bootstrap/css/bootstrap.min.css",
		// window.location.origin + "assets/vendors/jquery-ui/jquery-ui.css",
		// window.location.origin + "assets/vendors/bootstrap-select/bootstrap-select.min.css",
		// window.location.origin + "assets/vendors/animate/animate.min.css",
		// window.location.origin + "assets/vendors/fontawesome/css/all.min.css",
		// window.location.origin + "assets/vendors/jarallax/jarallax.css",
		// window.location.origin + "assets/vendors/jquery-magnific-popup/jquery.magnific-popup.css",
		// window.location.origin + "assets/vendors/nouislider/nouislider.min.css",
		// window.location.origin + "assets/vendors/nouislider/nouislider.pips.css",
		// window.location.origin + "assets/vendors/tiny-slider/tiny-slider.css",
		// window.location.origin + "assets/vendors/solinom-icons/style.css",
		// window.location.origin + "assets/vendors/owl-carousel/css/owl.carousel.min.css",
		// window.location.origin + "assets/vendors/owl-carousel/css/owl.theme.default.min.css",
		// window.location.origin + "assets/vendors/slick-carousel/slick.css",
		// window.location.origin + "assets/vendors/flipster/flipster.css",
		// window.location.origin + "assets/css/solinom.css",

    window.location.origin + "/assets/vendors/jquery/jquery-3.7.0.min.js",
		"https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.30.1/moment.min.js",
		"https://cdnjs.cloudflare.com/ajax/libs/tempusdominus-bootstrap-4/5.39.0/js/tempusdominus-bootstrap-4.min.js",
    window.location.origin + "/assets/vendors/bootstrap/js/bootstrap.bundle.min.js",
    window.location.origin + "/assets/vendors/bootstrap-select/bootstrap-select.min.js",
    window.location.origin + "/assets/vendors/jarallax/jarallax.min.js",
    window.location.origin + "/assets/vendors/jquery-ui/jquery-ui.js",
    window.location.origin + "/assets/vendors/jquery-ajaxchimp/jquery.ajaxchimp.min.js",
    window.location.origin + "/assets/vendors/jquery-appear/jquery.appear.min.js",
    window.location.origin + "/assets/vendors/jquery-circle-progress/jquery.circle-progress.min.js",
		window.location.origin + "/assets/vendors/jquery-magnific-popup/jquery.magnific-popup.min.js",
		window.location.origin + "/assets/vendors/jquery-validate/jquery.validate.min.js",
		window.location.origin + "/assets/vendors/nouislider/nouislider.min.js",
		window.location.origin + "/assets/vendors/tiny-slider/tiny-slider.js",
		window.location.origin + "/assets/vendors/wnumb/wNumb.min.js",
		window.location.origin + "/assets/vendors/owl-carousel/js/owl.carousel.min.js",
		window.location.origin + "/assets/vendors/slick-carousel/slick.min.js",
		window.location.origin + "/assets/vendors/flipster/flipster.js",
		window.location.origin + "/assets/vendors/wow/wow.js",
		window.location.origin + "/assets/vendors/imagesloaded/imagesloaded.min.js",
		window.location.origin + "/assets/vendors/isotope/isotope.js",
		window.location.origin + "/assets/vendors/countdown/countdown.min.js",
		window.location.origin + "/assets/vendors/jquery-circleType/jquery.circleType.js",
		window.location.origin + "/assets/vendors/jquery-lettering/jquery.lettering.min.js",
		
		window.location.origin + "/assets/vendors/gsap/gsap.js",
		window.location.origin + "/assets/vendors/gsap/ScrollTrigger.min.js",
		window.location.origin + "/assets/vendors/gsap/splittext.min.js",
		window.location.origin + "/assets/js/solinom-gsap.js",
		window.location.origin + "/assets/js/solinom.js",
  ], arrAdditional = [
		// window.location.origin + "/assets/js/solinom.js",
	];



  function addScript(arr, index = 0) {
    var scriptTag = document.createElement("script");
    scriptTag.src = arr[index];
    document.getElementsByTagName("head")[0].appendChild(scriptTag);

    if (arr[index + 1] != null) {
      // var context = this
      setTimeout(() => {
        addScript(arr, index + 1);
      }, 100);
    }
    else{
			setTimeout(() => {
    		$(".preloader").fadeOut();
			}, window.location.pathname == '/' ? 4000 : 1000)
		}
  }

  useEffect(() => {
		addScript(arr);
		// setTimeout(() => {
		// 	addScript(arrAdditional);
		// }, 20000)

		
  }, []);

	if (import.meta.hot) {
		import.meta.hot.dispose(() => router.dispose());
	}

	useEffect(() => {

		// const last_version = localStorage.getItem('version')
		// if (last_version == null || (last_version != null && last_version !== base.app_version)) {
		// 	localStorage.setItem('version', base.app_version)
		// 	window.location.reload(true);
		// }

		// setDefaultLang()
	}, [])



	async function setDefaultLang(){
		var lang = window.localStorage.getItem('lang')
		if(lang == null){
			await window.localStorage.setItem('lang','id')
			i18n.changeLanguage('id')
		}
	}

  return (

    	<FsLightboxContextProvider>
				{
					router != null &&
					<RouterProvider router={router} />

				}

    	</FsLightboxContextProvider>
  );
}

export default App;
